import React, { useState } from 'react';
import MatchHeaderOngoingFinished from '../components/MatchDetails/MatchHeaderOngoingFinished';
import MatchStats from '../components/MatchDetails/MatchStats';
import Formation from '../components/MatchDetails/Formation';
import Timeline from '../components/MatchDetails/Timeline';
import Playlist from '../components/MatchDetails/Playlist';
import LatestGames from '../components/MatchDetails/LatestGames';
import { isMatchEventPlayable } from '../utils/matchevents';
import TeamForm from '../components/MatchDetails/TeamForm';
import TeamNews from '../components/MatchDetails/TeamNews';
import TopPlayers from '../components/MatchDetails/TopPlayers';
import MatchUpStandings from '../components/MatchDetails/MatchUpStandings';
import { LEAGUES } from '../constants/leagues';
import FutsalFormation from '../components/MatchDetails/FutsalFormation';
import HighlightsReel from '../components/FotbollPlay/HighlightsReel';
import LiveStream from '../components/FotbollPlay/LiveStream';
import { MATCH_STATUS } from '../constants/match';
import Tabs from '../components/MatchDetails/Tabs';

function getInitialTab(status) {
  if (status === MATCH_STATUS.ONGOING) {
    return 1;
  }
  if (status === MATCH_STATUS.FINISHED) {
    return 1;
  }

  return 1;
}

function MatchDetailsOngoingFinished({
  match,
  homeTeamLogo,
  visitingTeamLogo,
  teamLogos,
}) {
  const [currentTab, setCurrentTab] = useState(getInitialTab(match?.status));

  const switchContent = (newTab) => {
    setCurrentTab(newTab);
  };

  return (
    <>
      <div className="site-container site-container--hug-on-mobile">
        <section className="hero-image">
          <a className="hero-image__back" href="/matcher">
            <img
              src="/wp-content/themes/sef-leagues/images/arrow-back.svg"
              alt="Back"
            />
          </a>
          <MatchHeaderOngoingFinished
            match={match}
            homeTeamLogo={homeTeamLogo}
            visitingTeamLogo={visitingTeamLogo}
          />
        </section>
      </div>
      <div className="site-container">
        {match?.configLeagueName !== LEAGUES.FUTSAL && (
          <section className="row">
            <div className="col-12 text-center mb-4 d-none d-lg-block">
              <a href="https://www.discoveryplus.se/" target="_blank" rel="nofollow noreferrer">
                <img
                  height="24"
                  src="/wp-content/themes/sef-leagues/images/discovery-plus-logo-white.svg"
                  alt=""
                />
              </a>
            </div>
          </section>
        )}
        <Tabs
          switchContent={switchContent}
          initialTab={getInitialTab(match?.status)}
        />
        {currentTab === 0 && (
          <MatchUpStandings match={match} teamLogos={teamLogos} />
        )}
        {currentTab === 0 && (
          <>
            <TeamNews
              teamLogo={homeTeamLogo}
              abbrv={match?.homeTeamAbbrv}
              teamName={match?.homeTeamName}
            />
            <TeamNews
              teamLogo={visitingTeamLogo}
              abbrv={match?.visitingTeamAbbrv}
              teamName={match?.visitingTeamName}
            />
          </>
        )}
        {match?.configLeagueName !== LEAGUES.FUTSAL && currentTab === 0 && (
          <TopPlayers match={match} />
        )}
        {currentTab === 0 && (
          <TeamForm
            match={match}
            homeTeamLogo={homeTeamLogo}
            visitingTeamLogo={visitingTeamLogo}
          />
        )}
        {currentTab === 1 && (
          <MatchStats
            match={match}
            homeTeamLogo={homeTeamLogo}
            visitingTeamLogo={visitingTeamLogo}
          />
        )}
        <section className="row mt-4">
          <div className="col-12">
            <div className="video__container video__container--two-col">
              {match?.playlists?.highlights && (
                <HighlightsReel
                  isFutsal={match?.configLeagueName === LEAGUES.FUTSAL}
                  video={match?.playlists?.highlights}
                />
              )}
              {match?.configLeagueName === LEAGUES.FUTSAL && (
                <LiveStream
                  match={match}
                  isFutsal={match?.configLeagueName === LEAGUES.FUTSAL}
                  video={match?.playlists?.match?.[0]}
                />
              )}
            </div>
          </div>
        </section>
        {match?.configLeagueName !== LEAGUES.FUTSAL && currentTab === 2 && (
          <>
            <Formation match={match} homeTeam />
            <Formation match={match} homeTeam={false} />
          </>
        )}
        {match?.configLeagueName === LEAGUES.FUTSAL && currentTab === 2 && (
          <FutsalFormation
            match={match}
            homeTeamLogo={homeTeamLogo}
            visitingTeamLogo={visitingTeamLogo}
          />
        )}
        {currentTab === 1 && <Timeline match={match} />}
        {/* <Playlist
          videos={match?.matchEvents.filter((m) =>
            isMatchEventPlayable(match, m)
          )}
        />
        <LatestGames match={match} /> */}
      </div>
    </>
  );
}

export default MatchDetailsOngoingFinished;
